"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Contentio API for client FE
 * This JNEXT technical microservice allows FE to upload and download content files
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 * Contact: luca.calderone@jakala.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentioApi = exports.ContentioApiFactory = exports.ContentioApiFp = exports.ContentioApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * ContentioApi - axios parameter creator
 * @export
 */
var ContentioApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary download
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateDownload: function (filename, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'filename' is not null or undefined
                    (0, common_1.assertParamExists)('privateDownload', 'filename', filename);
                    localVarPath = "/private/download";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (filename !== undefined) {
                        localVarQueryParameter['filename'] = filename;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * upload
         * @summary upload (for multiple large file)
         * @param {string} moduleName \&#39;moduleName\&#39; is the first directory of the destination path before /tenant/project (if tenant and project are provided in request headers).
         * @param {any} files
         * @param {string} [middlePath] \&#39;middlePath\&#39; is the path where the file(s) will be uploaded The final path is composed by bucket/public|private|sts/moduleName[/tenant][/project][/middlePath] (if tenant and project are provided in request headers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateUpload: function (moduleName, files, middlePath, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'moduleName' is not null or undefined
                    (0, common_1.assertParamExists)('privateUpload', 'moduleName', moduleName);
                    // verify required parameter 'files' is not null or undefined
                    (0, common_1.assertParamExists)('privateUpload', 'files', files);
                    localVarPath = "/private/upload";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                    if (moduleName !== undefined) {
                        localVarQueryParameter['moduleName'] = moduleName;
                    }
                    if (middlePath !== undefined) {
                        localVarQueryParameter['middlePath'] = middlePath;
                    }
                    if (files !== undefined) {
                        localVarFormParams.append('files', files);
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ContentioApiAxiosParamCreator = ContentioApiAxiosParamCreator;
/**
 * ContentioApi - functional programming interface
 * @export
 */
var ContentioApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContentioApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary download
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateDownload: function (filename, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.privateDownload(filename, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * upload
         * @summary upload (for multiple large file)
         * @param {string} moduleName \&#39;moduleName\&#39; is the first directory of the destination path before /tenant/project (if tenant and project are provided in request headers).
         * @param {any} files
         * @param {string} [middlePath] \&#39;middlePath\&#39; is the path where the file(s) will be uploaded The final path is composed by bucket/public|private|sts/moduleName[/tenant][/project][/middlePath] (if tenant and project are provided in request headers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateUpload: function (moduleName, files, middlePath, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.privateUpload(moduleName, files, middlePath, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ContentioApiFp = ContentioApiFp;
/**
 * ContentioApi - factory interface
 * @export
 */
var ContentioApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContentioApiFp)(configuration);
    return {
        /**
         *
         * @summary download
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateDownload: function (filename, options) {
            return localVarFp.privateDownload(filename, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * upload
         * @summary upload (for multiple large file)
         * @param {string} moduleName \&#39;moduleName\&#39; is the first directory of the destination path before /tenant/project (if tenant and project are provided in request headers).
         * @param {any} files
         * @param {string} [middlePath] \&#39;middlePath\&#39; is the path where the file(s) will be uploaded The final path is composed by bucket/public|private|sts/moduleName[/tenant][/project][/middlePath] (if tenant and project are provided in request headers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateUpload: function (moduleName, files, middlePath, options) {
            return localVarFp.privateUpload(moduleName, files, middlePath, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContentioApiFactory = ContentioApiFactory;
/**
 * ContentioApi - object-oriented interface
 * @export
 * @class ContentioApi
 * @extends {BaseAPI}
 */
var ContentioApi = /** @class */ (function (_super) {
    __extends(ContentioApi, _super);
    function ContentioApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary download
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentioApi
     */
    ContentioApi.prototype.privateDownload = function (filename, options) {
        var _this = this;
        return (0, exports.ContentioApiFp)(this.configuration).privateDownload(filename, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * upload
     * @summary upload (for multiple large file)
     * @param {string} moduleName \&#39;moduleName\&#39; is the first directory of the destination path before /tenant/project (if tenant and project are provided in request headers).
     * @param {any} files
     * @param {string} [middlePath] \&#39;middlePath\&#39; is the path where the file(s) will be uploaded The final path is composed by bucket/public|private|sts/moduleName[/tenant][/project][/middlePath] (if tenant and project are provided in request headers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentioApi
     */
    ContentioApi.prototype.privateUpload = function (moduleName, files, middlePath, options) {
        var _this = this;
        return (0, exports.ContentioApiFp)(this.configuration).privateUpload(moduleName, files, middlePath, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContentioApi;
}(base_1.BaseAPI));
exports.ContentioApi = ContentioApi;
